import React, { useState } from "react";
import multipatch from "../../assets/Multipatch.png";
import multipat from "../../assets/ban.png";
import {
  FaTruck,
  FaGlobe,
  FaArrowsAltH,
  FaDollarSign,
  FaPercent,
  FaThumbsUp,
} from "react-icons/fa";

const features = [
  {
    id: 1,
    icon: <FaTruck className="text-2xl text-white" />,
    title: "5 Day Production, Low Minimums",
    desc: "Our Fast option produces patches in five days — available for select patch types, including options with low minimums starting at just 10 patches.",
  },
  {
    id: 2,
    icon: <FaGlobe className="text-2xl text-white" />,
    title: "High Quality Materials",
    desc: "Our patches feature premium threads and durable fabrics for sharp, vibrant designs that endure daily wear and washing.",
  },
  {
    id: 3,
    icon: <FaArrowsAltH className="text-2xl text-white" />,
    title: "Versatile Attachment Options",
    desc: "We offer various backing options, including heat press, iron-on, peel-and-stick, and Velcro, to suit your application needs.",
  },
  {
    id: 4,
    icon: <FaDollarSign className="text-2xl text-white" />,
    title: "No Setup or Art Fees",
    desc: "To keep our embroidered patches and other patch types affordable, there are no set up or art fees.",
  },
  {
    id: 5,
    icon: <FaPercent className="text-2xl text-white" />,
    title: "Bulk Order Discounts",
    desc: "Save up to 74% on bulk orders — the more you buy, the more you save!",
  },
  {
    id: 6,
    icon: <FaThumbsUp className="text-2xl text-white" />,
    title: "Satisfaction Guarantee",
    desc: "Report production errors within 45 days for a replacement or refund. No returns needed before approval.",
  },
];

const WhyBuySection = () => {
  const [openFaq, setOpenFaq] = useState(0);

  const faqs = [
    {
      question: "What is a patch on a shirt?",
      answer:
        "A patch on a shirt is a piece of fabric used for decoration, branding, or repair.",
    },
    {
      question: "How can I put a patch on a shirt?",
      answer:
        "You can apply patches using sewing or heat with custom shirt patches iron on.",
    },
    {
      question: "What are the three types of patches?",
      answer:
        "The three main types are embroidered patches, woven patches, and PVC patches.",
    },
  ];

  return (
    <section className="w-full bg-lightPastelPurple/40 px-4 py-12 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-[1440px]">
        <div className="mx-auto max-w-[1280px] space-y-14">
          {/* Section 1 */}
          <div className="relative overflow-hidden rounded-[26px] border border-pastelPurple bg-white shadow-[0_14px_35px_rgba(47,34,84,0.08)]">
  <div className="absolute -left-20 -top-20 h-56 w-56 rounded-full bg-pastelPurple/60 blur-3xl"></div>
  <div className="absolute -right-20 -bottom-20 h-56 w-56 rounded-full bg-keyLime/20 blur-3xl"></div>

  <div className="relative grid items-stretch lg:grid-cols-[0.92fr_1.08fr]">
    <div className="relative flex min-h-[310px] items-center justify-center overflow-hidden bg-gradient-to-br from-[#f2ecff] via-white to-[#f8ffe0] p-5 md:min-h-[350px] md:p-6 lg:min-h-full">
      <div className="absolute left-6 top-6 h-16 w-16 rounded-[20px] bg-keyLime/60"></div>
      <div className="absolute bottom-6 right-6 h-20 w-20 rounded-full border-[12px] border-white/70"></div>
      <div className="absolute inset-x-8 bottom-6 h-20 rounded-full bg-darkPurple/10 blur-2xl"></div>

      <div className="relative z-10 flex h-full w-full items-center justify-center rounded-[24px] border border-white/80 bg-white/45 p-4 backdrop-blur-sm">
        <img
          src={multipatch}
          alt="Custom Patches"
          className="h-full max-h-[410px] w-full object-contain drop-shadow-[0_18px_28px_rgba(33,27,51,0.18)]"
        />
      </div>
    </div>

    <div className="relative flex flex-col justify-center p-5 md:p-6 lg:p-8">
      <div className="absolute right-8 top-8 hidden h-12 w-12 rounded-2xl bg-pastelPurple/60 lg:block"></div>

      <div className="relative max-w-2xl">
        <h2 className="text-2xl font-extrabold leading-tight tracking-tight text-darkPurple md:text-3xl">
          Design Unique custom patches for shirts
        </h2>

        <div className="mt-4 flex items-center gap-3">
          <span className="h-1 w-14 rounded-full bg-keyLime"></span>
          <span className="h-1 w-7 rounded-full bg-pastelPurple"></span>
        </div>

        <p className="mt-5 text-base font-medium leading-7 text-[#5f5870] md:text-lg md:leading-8">
          With our easy process, you can create custom patches for shirts that match your vision. You can make your own shirts patches using logos, text, or creative artwork.
        </p>

        <ul className="mt-5 grid gap-3">
          <li className="relative flex overflow-hidden rounded-2xl border border-pastelPurple bg-white px-5 py-3 text-sm font-medium leading-6 text-[#5f5870] shadow-sm md:text-base">
            <span className="absolute left-0 top-0 h-full w-1.5 bg-keyLime"></span>
            <span className="block pl-3">
              Modern shirt patches design for all styles
            </span>
          </li>

          <li className="relative flex overflow-hidden rounded-2xl border border-pastelPurple bg-white px-5 py-3 text-sm font-medium leading-6 text-[#5f5870] shadow-sm md:text-base">
            <span className="absolute left-0 top-0 h-full w-1.5 bg-keyLime"></span>
            <span className="block pl-3">
              Premium custom made patches for shirts
            </span>
          </li>

          <li className="relative flex overflow-hidden rounded-2xl border border-pastelPurple bg-white px-5 py-3 text-sm font-medium leading-6 text-[#5f5870] shadow-sm md:text-base">
            <span className="absolute left-0 top-0 h-full w-1.5 bg-keyLime"></span>
            <span className="block pl-3">
              Fully shirts patches personalized for branding
            </span>
          </li>
        </ul>

        <p className="mt-5 text-base font-medium leading-7 text-[#5f5870] md:text-lg md:leading-8">
          Our collection includes shirts patches for men and women, making customization simple for everyone.
        </p>
      </div>
    </div>
  </div>
</div>

          {/* New Section updated content */}
         

          {/* New Section updated content */}
         <div className="relative mx-auto max-w-7xl overflow-hidden rounded-[26px] border border-pastelPurple bg-white shadow-[0_14px_35px_rgba(47,34,84,0.08)]">
  <div className="absolute left-0 top-0 h-56 w-56 rounded-full bg-pastelPurple/55 blur-3xl"></div>
  <div className="absolute bottom-0 right-0 h-56 w-56 rounded-full bg-keyLime/20 blur-3xl"></div>

  <div className="relative p-5 md:p-6 lg:p-8">
    <div className="mx-auto max-w-5xl text-center">
      <h2 className="text-2xl font-extrabold leading-tight tracking-tight text-darkPurple md:text-3xl">
        shirts patches vs custom patches for shirts- What’s the Difference?
      </h2>

      <div className="mx-auto mt-3 flex w-full max-w-[210px] items-center justify-center gap-3">
        <span className="h-[1px] flex-1 bg-[#d8c8ff]"></span>
        <span className="h-2.5 w-2.5 rounded-full bg-keyLime shadow-[0_0_0_5px_rgba(215,255,79,0.25)]"></span>
        <span className="h-[1px] flex-1 bg-[#d8c8ff]"></span>
      </div>

      <p className="mt-5 text-base font-medium leading-7 text-[#5f5870] md:text-lg md:leading-8">
        Choosing between ready-made shirts patches and custom patches for shirts can impact your style, branding, and overall quality. Here’s a clear comparison to help you decide:
      </p>
    </div>

    <div className="mt-6 grid gap-5 lg:grid-cols-2">
      <div className="rounded-[22px] border border-pastelPurple bg-lightPastelPurple p-5">
        <p className="text-lg font-extrabold text-darkPurple">
          🔹 Standard shirts patches
        </p>

        <ul className="mt-4 space-y-3 text-base font-medium leading-6 text-[#5f5870]">
          <li className="rounded-2xl border border-pastelPurple bg-white px-5 py-3">
            Pre-designed and ready to use
          </li>
          <li className="rounded-2xl border border-pastelPurple bg-white px-5 py-3">
            Limited options in shirt patches design
          </li>
          <li className="rounded-2xl border border-pastelPurple bg-white px-5 py-3">
            Faster purchase with shirt patches for sale
          </li>
          <li className="rounded-2xl border border-pastelPurple bg-white px-5 py-3">
            Good for simple and quick styling
          </li>
          <li className="rounded-2xl border border-pastelPurple bg-white px-5 py-3">
            Available in bulk like shirts patches wholesale no minimum
          </li>
          <li className="rounded-2xl border border-pastelPurple bg-white px-5 py-3">
            Easy to find through shirt patches online or local stores
          </li>
        </ul>
      </div>

      <div className="rounded-[22px] border border-pastelPurple bg-darkPurple p-5">
        <p className="text-lg font-extrabold text-white">
          🔹 Personalized custom patches for shirts
        </p>

        <ul className="mt-4 space-y-3 text-base font-medium leading-6 text-[#f2ecff]">
          <li className="rounded-2xl border border-white/10 bg-white/10 px-5 py-3">
            Fully customizable to match your vision
          </li>
          <li className="rounded-2xl border border-white/10 bg-white/10 px-5 py-3">
            Unique and creative shirt patches design
          </li>
          <li className="rounded-2xl border border-white/10 bg-white/10 px-5 py-3">
            Option to make your own shirts patches
          </li>
          <li className="rounded-2xl border border-white/10 bg-white/10 px-5 py-3">
            Premium quality with custom made patches for shirts
          </li>
          <li className="rounded-2xl border border-white/10 bg-white/10 px-5 py-3">
            Better branding with shirts patches personalized
          </li>
          <li className="rounded-2xl border border-white/10 bg-white/10 px-5 py-3">
            Created by expert shirt patch maker
          </li>
          <li className="rounded-2xl border border-white/10 bg-white/10 px-5 py-3">
            Flexible options like custom shirt patches iron on
          </li>
        </ul>
      </div>
    </div>

    <div className="mx-auto mt-6 max-w-5xl rounded-[22px] border border-pastelPurple bg-white p-5 shadow-sm">
      <h2 className="text-center text-2xl font-extrabold leading-tight tracking-tight text-darkPurple md:text-3xl">
        Explore Creative shirt patches design
      </h2>

      <p className="mt-4 text-center text-base font-medium leading-7 text-[#5f5870] md:text-lg md:leading-8">
        Our shirt patches design options give you full control over your style. You can create simple or bold designs that reflect your personality or brand.
      </p>

      <p className="mt-4 text-base font-medium leading-7 text-[#5f5870] md:text-lg md:leading-8">
        With our expertise, you can:
      </p>

      <ul className="mt-3 grid gap-3 text-base font-medium leading-6 text-[#5f5870] md:grid-cols-3">
        <li className="rounded-2xl border border-pastelPurple bg-lightPastelPurple px-5 py-3">
          Customize colors and shapes
        </li>
        <li className="rounded-2xl border border-pastelPurple bg-lightPastelPurple px-5 py-3">
          Order detailed custom made patches for shirts
        </li>
        <li className="rounded-2xl border border-pastelPurple bg-lightPastelPurple px-5 py-3">
          Create standout shirt patches for any purpose
        </li>
      </ul>

      <p className="mt-5 text-center text-base font-medium leading-7 text-[#5f5870] md:text-lg md:leading-8">
        Our shirts patches are crafted to deliver both quality and visual appeal.
      </p>
    </div>
  </div>
</div>

          

          {/* Section 2 */}
          <div className="relative overflow-hidden rounded-[24px] border border-pastelPurple bg-white p-4 shadow-[0_12px_28px_rgba(47,34,84,0.08)] md:p-5 lg:p-6">
  <div className="absolute left-0 top-0 h-48 w-48 rounded-full bg-pastelPurple/50 blur-3xl"></div>
  <div className="absolute bottom-0 right-0 h-48 w-48 rounded-full bg-keyLime/20 blur-3xl"></div>

  <div className="relative mx-auto max-w-4xl text-center">
    <h2 className="text-2xl font-extrabold leading-tight tracking-tight text-darkPurple md:text-3xl">
      Buy Quality shirt patches online
    </h2>

    <div className="mx-auto mt-3 flex w-full max-w-[190px] items-center justify-center gap-3">
      <span className="h-[1px] flex-1 bg-[#d8c8ff]"></span>
      <span className="h-2.5 w-2.5 rounded-full bg-keyLime shadow-[0_0_0_5px_rgba(215,255,79,0.25)]"></span>
      <span className="h-[1px] flex-1 bg-[#d8c8ff]"></span>
    </div>

    <p className="mt-4 text-base font-medium leading-7 text-[#5f5870] md:text-lg">
      Shopping for shirt patches online is quick and easy with our platform. You can browse styles, customize designs, and place orders in minutes.
    </p>

    <div className="mx-auto mt-4 max-w-3xl rounded-2xl border border-pastelPurple bg-lightPastelPurple p-4">
      <p className="text-left text-base font-medium leading-7 text-[#5f5870] md:text-lg">
        We offer:
      </p>

      <ul className="mt-3 grid gap-2.5 text-left">
        <li className="rounded-xl border border-pastelPurple bg-white px-4 py-2.5 text-base font-medium leading-6 text-[#5f5870] md:text-lg">
          Affordable shirt patches for sale
        </li>

        <li className="rounded-xl border border-pastelPurple bg-white px-4 py-2.5 text-base font-medium leading-6 text-[#5f5870] md:text-lg">
          Fast shipping if you’re searching for shirt patches near me
        </li>

        <li className="rounded-xl border border-pastelPurple bg-white px-4 py-2.5 text-base font-medium leading-6 text-[#5f5870] md:text-lg">
          A wide range of shirt patches for different needs
        </li>
      </ul>
    </div>

    <p className="mt-4 text-base font-medium leading-7 text-[#5f5870] md:text-lg">
      When comparing shirts patches vs custom shirts patches, custom options give you better flexibility and uniqueness.
    </p>
  </div>
</div>

    

          {/* Section 3 */}
          <div className="space-y-4">
            <div>
              <img
                src={multipat}
                alt="Multipatch"
                className="w-full max-w-full mx-auto rounded-2xl shadow-xl hover:scale-105 transition-transform duration-300 object-cover"
              />
            </div>
          </div>

          <section className="relative mx-auto mt-14 max-w-7xl overflow-hidden rounded-[30px] border border-pastelPurple bg-white shadow-[0_18px_45px_rgba(47,34,84,0.08)]">
            <div className="absolute left-0 top-0 h-72 w-72 rounded-full bg-pastelPurple/60 blur-3xl"></div>
            <div className="absolute bottom-0 right-0 h-72 w-72 rounded-full bg-keyLime/20 blur-3xl"></div>

            <div className="relative grid gap-8 p-6 md:p-8 lg:grid-cols-[0.85fr_1.15fr] lg:p-10">
              <div className="flex items-center rounded-[24px] bg-darkPurple p-6 md:p-8">
                <h2 className="text-2xl font-extrabold leading-tight tracking-tight text-white md:text-3xl">
                  Simple Guide on how do patches work on clothes
                </h2>
              </div>

              <div className="flex flex-col justify-center">
                <p className="text-base font-medium leading-8 text-[#5f5870] md:text-lg">
                  Many customers ask, how do patches work on clothes? The answer is simple. Patches can be applied using heat, stitching, or adhesive backing.
                </p>

                <p className="mt-5 text-base font-medium leading-8 text-[#5f5870] md:text-lg">
                  We provide:
                </p>

                <ul className="mt-4 space-y-3 text-base font-medium leading-8 text-[#5f5870] md:text-lg">
                  <li className="rounded-2xl border border-pastelPurple bg-lightPastelPurple px-5 py-3">
                     Easy custom shirt patches iron on solutions
                  </li>

                  <li className="rounded-2xl border border-pastelPurple bg-lightPastelPurple px-5 py-3">
                     Durable iron on letter patches for shirts
                  </li>

                  <li className="rounded-2xl border border-pastelPurple bg-lightPastelPurple px-5 py-3">
                     Expert help if you’re learning how to make patches for shirts
                  </li>
                </ul>

                <p className="mt-5 text-base font-medium leading-8 text-[#5f5870] md:text-lg">
                  As a reliable shirt patch maker, we ensure every patch is made for easy use and long-term wear.
                </p>
              </div>
            </div>
          </section>

          

          <section className="relative w-full overflow-hidden bg-lightPastelPurple px-4 py-14 md:py-16">
            <div className="absolute left-0 top-10 h-72 w-72 rounded-full bg-pastelPurple opacity-60 blur-3xl"></div>
            <div className="absolute bottom-10 right-0 h-72 w-72 rounded-full bg-keyLime/20 blur-3xl"></div>

            <div className="relative mx-auto max-w-7xl overflow-hidden rounded-[30px] border border-pastelPurple bg-white p-6 shadow-[0_18px_45px_rgba(47,34,84,0.08)] md:p-8 lg:p-10">
              <div className="absolute left-0 top-0 h-72 w-72 rounded-full bg-pastelPurple/60 blur-3xl"></div>
              <div className="absolute bottom-0 right-0 h-72 w-72 rounded-full bg-keyLime/20 blur-3xl"></div>

              <div className="relative mx-auto max-w-4xl text-center">
                <h2 className="text-2xl font-extrabold leading-tight tracking-tight text-darkPurple md:text-3xl">
                  Bulk Orders with shirts patches wholesale no minimum
                </h2>

                <div className="mx-auto mt-4 flex w-full max-w-[230px] items-center justify-center gap-3">
                  <span className="h-[1px] flex-1 bg-[#d8c8ff]"></span>
                  <span className="h-2.5 w-2.5 rounded-full bg-keyLime shadow-[0_0_0_5px_rgba(215,255,79,0.25)]"></span>
                  <span className="h-[1px] flex-1 bg-[#d8c8ff]"></span>
                </div>

                <p className="mt-6 text-base font-medium leading-8 text-[#5f5870] md:text-lg">
                  Need patches in bulk? We offer shirts patches wholesale no minimum, perfect for businesses, teams, and events.
                </p>

                <div className="mx-auto mt-6 max-w-3xl rounded-2xl border border-pastelPurple bg-lightPastelPurple p-5 md:p-6">
                  <p className="text-left text-base font-medium leading-8 text-[#5f5870] md:text-lg">
                    Our services include:
                  </p>

                  <ul className="mt-4 grid gap-3 text-left">
                    <li className="rounded-2xl border border-pastelPurple bg-white px-5 py-3 text-base font-medium leading-8 text-[#5f5870] md:text-lg">
                       Fully shirts patches personalized solutions
                    </li>

                    <li className="rounded-2xl border border-pastelPurple bg-white px-5 py-3 text-base font-medium leading-8 text-[#5f5870] md:text-lg">
                       Bulk-friendly pricing
                    </li>

                    <li className="rounded-2xl border border-pastelPurple bg-white px-5 py-3 text-base font-medium leading-8 text-[#5f5870] md:text-lg">
                       Fast production across the USA
                    </li>
                  </ul>
                </div>

                <p className="mt-6 text-base font-medium leading-8 text-[#5f5870] md:text-lg">
                  Our shirts patches help you maintain a consistent and professional look.
                </p>
              </div>
            </div>
          </section>

          {/* Section 4 */}
        <div className="relative overflow-hidden rounded-[24px] border border-pastelPurple bg-white p-4 shadow-[0_12px_28px_rgba(47,34,84,0.08)] md:p-5 lg:p-6">
  <div className="absolute left-0 top-0 h-48 w-48 rounded-full bg-pastelPurple/50 blur-3xl"></div>
  <div className="absolute bottom-0 right-0 h-48 w-48 rounded-full bg-keyLime/20 blur-3xl"></div>

  <div className="relative mx-auto max-w-4xl text-center">
    <h2 className="text-2xl font-extrabold leading-tight tracking-tight text-darkPurple md:text-3xl">
      Premium Patch Quality
    </h2>

    <div className="mx-auto mt-3 flex w-full max-w-[190px] items-center justify-center gap-3">
      <span className="h-[1px] flex-1 bg-[#d8c8ff]"></span>
      <span className="h-2.5 w-2.5 rounded-full bg-keyLime shadow-[0_0_0_5px_rgba(215,255,79,0.25)]"></span>
      <span className="h-[1px] flex-1 bg-[#d8c8ff]"></span>
    </div>

    <p className="mt-4 text-base font-medium leading-7 text-[#5f5870] md:text-lg">
      Our custom patches for shirts are made using high-quality materials that ensure durability and comfort. Each patch is designed to enhance your clothing with a clean and professional finish.
    </p>

    <p className="mt-3 text-base font-medium leading-7 text-[#5f5870] md:text-lg">
      With options like custom shirt patches iron on and sew-on backing, applying patches is simple. Whether you need logos or artwork, our shirt patches design ensures great results.
    </p>

    <div className="mx-auto mt-4 max-w-3xl rounded-2xl border border-pastelPurple bg-lightPastelPurple p-4">
      <p className="text-left text-base font-medium leading-7 text-[#5f5870] md:text-lg">
        Perfect for:
      </p>

      <ul className="mt-3 grid gap-2.5 text-left md:grid-cols-3">
        <li className="rounded-xl border border-pastelPurple bg-white px-4 py-2.5 text-base font-medium leading-6 text-[#5f5870]">
          Fashion brands
        </li>

        <li className="rounded-xl border border-pastelPurple bg-white px-4 py-2.5 text-base font-medium leading-6 text-[#5f5870]">
          Work uniforms
        </li>

        <li className="rounded-xl border border-pastelPurple bg-white px-4 py-2.5 text-base font-medium leading-6 text-[#5f5870]">
          Personal styling
        </li>
      </ul>
    </div>
  </div>
</div>

         

          {/* CTA */}
          <div className="relative overflow-hidden rounded-[24px] border border-pastelPurple bg-darkPurple px-5 py-7 text-center shadow-[0_12px_28px_rgba(47,34,84,0.14)] md:px-6 md:py-8">
  <div className="absolute -left-16 -top-16 h-48 w-48 rounded-full bg-pastelPurple/30 blur-3xl"></div>
  <div className="absolute -right-16 -bottom-16 h-48 w-48 rounded-full bg-keyLime/25 blur-3xl"></div>

  <div className="relative mx-auto max-w-2xl">
    <h2 className="text-2xl font-extrabold leading-tight tracking-tight text-white md:text-3xl">
      Start Designing Your Patch
    </h2>

    <div className="mx-auto mt-3 h-1 w-16 rounded-full bg-keyLime"></div>

    <p className="mx-auto mt-4 max-w-md text-base font-medium leading-7 text-[#f2ecff]">
      Bring your ideas to life with professional patch designers.
    </p>
  </div>
</div>

          {/* FAQ SECTION */}
         <div className="relative overflow-hidden rounded-[24px] border border-pastelPurple bg-white p-4 shadow-[0_12px_28px_rgba(47,34,84,0.08)] md:p-5 lg:p-6">
  <div className="absolute left-0 top-0 h-48 w-48 rounded-full bg-pastelPurple/50 blur-3xl"></div>
  <div className="absolute bottom-0 right-0 h-48 w-48 rounded-full bg-keyLime/20 blur-3xl"></div>

  <div className="relative mx-auto max-w-3xl">
    <div className="text-center">
      <h2 className="text-3xl font-extrabold tracking-tight text-darkPurple md:text-4xl">
        FAQs
      </h2>

      <div className="mx-auto mt-3 flex w-full max-w-[190px] items-center justify-center gap-3">
        <span className="h-[1px] flex-1 bg-[#d8c8ff]"></span>
        <span className="h-2.5 w-2.5 rounded-full bg-keyLime shadow-[0_0_0_5px_rgba(215,255,79,0.25)]"></span>
        <span className="h-[1px] flex-1 bg-[#d8c8ff]"></span>
      </div>
    </div>

    <div className="mt-6 space-y-3">
      {faqs.map((faq, index) => (
        <div
          key={faq.question}
          className="overflow-hidden rounded-2xl border border-pastelPurple bg-white shadow-[0_10px_24px_rgba(47,34,84,0.07)]"
        >
          <button
            type="button"
            onClick={() => setOpenFaq(openFaq === index ? null : index)}
            className="flex w-full items-center justify-between gap-4 px-5 py-3.5 text-left"
          >
            <span className="text-base font-extrabold text-darkPurple md:text-lg">
              {faq.question}
            </span>

            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-xl bg-keyLime text-lg font-extrabold text-darkPurple">
              {openFaq === index ? "−" : "+"}
            </span>
          </button>

          <div
            className={`grid transition-all duration-300 ease-in-out ${
              openFaq === index
                ? "grid-rows-[1fr] opacity-100"
                : "grid-rows-[0fr] opacity-0"
            }`}
          >
            <div className="overflow-hidden">
              <p className="border-t border-pastelPurple px-5 py-3.5 text-base font-medium leading-7 text-[#5f5870] md:text-lg">
                {faq.answer}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</div>
        </div>
      </div>

      
    </section>
  );
};

export default WhyBuySection;